import { defineMessages } from 'react-intl';

// Pricing-section strings. IDs are kept identical to their previous home in
// Services.messages.js so translations and i18n extraction don't churn.
export const messages = defineMessages({
  pricing: {
    id: 'manage-services.services.form.pricing',
    defaultMessage: 'Pricing',
  },
  payout: {
    id: 'manage-services.services.form.payout',
    defaultMessage: 'Payout',
  },
  pricingInfoBanner: {
    id: 'manage-services.services.form.pricing-info-banner',
    defaultMessage: 'We must verify the price of this service before it becomes available to book.',
  },
  pricingUpdateInfoBanner: {
    id: 'manage-services.services.form.pricing-update-info-banner',
    defaultMessage:
      'If your menu price changes, our team will need to verify the new price before it becomes available to order.',
  },
  // LEGACY (flag: partner_dashboard_service_pricing_proof off) — consumed only
  // by LegacyServicePricingInputs. Remove when the flag is retired.
  notListedOnline: {
    id: 'manage-services.services.form.not-listed-online',
    defaultMessage: 'My prices are not listed online.',
  },
  servicePrice: {
    id: 'manage-services.services.form.service-price',
    defaultMessage: 'Service price',
  },
  servicePriceDescriptionUSA: {
    id: 'manage-services.services.form.service-price-description-usa',
    defaultMessage: 'The price of your service, not including tax. We’ll use this to calculate your payout.',
  },
  servicePriceDescription: {
    id: 'manage-services.services.form.service-price-description',
    defaultMessage: 'The price of your service, including tax. We’ll use this to calculate your payout.',
  },
  linkToPrice: {
    id: 'manage-services.services.form.link-to-price',
    defaultMessage: 'Link to pricing',
  },
  linkToPriceTooltip: {
    id: 'manage-services.services.form.link-to-price-tooltip',
    defaultMessage: 'Where prices are provided on your customer-facing website.',
  },
  linkToPricePlaceholder: {
    id: 'manage-services.services.form.link-to-price-placeholder',
    defaultMessage: 'www.example.com/pricing',
  },
  linkToPriceDescription: {
    id: 'manage-services.services.form.link-to-price-description',
    defaultMessage: 'Required for price verification.',
  },
  noLinkUploadPrompt: {
    id: 'manage-services.services.form.no-link-upload-prompt',
    defaultMessage: 'No link to pricing?',
  },
  proofRequired: {
    id: 'manage-services.services.form.proof-required',
    defaultMessage: 'Add a link to pricing or upload a pdf or image.',
  },
  invalidUrl: {
    id: 'manage-services.services.form.invalid-url',
    defaultMessage: 'A valid link is required.',
  },
  contactSupport: {
    id: 'manage-services.services.form.contact-support',
    defaultMessage: 'Contact support',
  },
  uploadProofLink: {
    id: 'manage-services.services.form.upload-proof-link',
    defaultMessage: 'Upload a pdf or image',
  },
  proofUnsupportedFileType: {
    id: 'manage-services.services.form.proof-unsupported-file-type',
    defaultMessage: 'Unsupported file type. Please upload a pdf or image.',
  },
  proofFileTooLarge: {
    id: 'manage-services.services.form.proof-file-too-large',
    defaultMessage: 'File is too large. Maximum size is 10MB.',
  },
  proofFilenameTooLong: {
    id: 'manage-services.services.form.proof-filename-too-long',
    defaultMessage: 'Filename too long. Maximum 50 characters.',
  },
  proofUploadFailed: {
    id: 'manage-services.services.form.proof-upload-failed',
    defaultMessage: 'Upload failed. Please try again.',
  },
  proofUploadNetworkError: {
    id: 'manage-services.services.form.proof-upload-network-error',
    defaultMessage:
      "Couldn't reach our file storage. Please check your connection and try again. If the problem persists, contact support.",
  },
  proofRemoveFile: {
    id: 'manage-services.services.form.proof-remove-file',
    defaultMessage: 'Remove file',
  },
  proofDownloadFile: {
    id: 'manage-services.services.form.proof-download-file',
    defaultMessage: 'Download file',
  },
  proofRetryFile: {
    id: 'manage-services.services.form.proof-retry-file',
    defaultMessage: 'Retry',
  },
  accountabilityAgreementTitle: {
    id: 'manage-services.services.form.accountability-agreement-title',
    defaultMessage: 'I hereby confirm the price provided is the true, standard, non-promotional price.',
  },
  accountabilityAgreementDescription: {
    id: 'manage-services.services.form.accountability-agreement-description',
    defaultMessage:
      'I understand that providing inaccurate pricing may result in the service being disabled and payouts being held pending investigation, as per the partner agreement.',
  },
  accountabilityAgreementRequired: {
    id: 'manage-services.services.form.accountability-agreement-required',
    defaultMessage: 'You must confirm the pricing accountability statement to submit.',
  },
});
